module.exports = __webpack_public_path__ + "static/enterprise-5b57f3191f06df7d0c7c5b1e9e332a98.png";